var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { TNPSReportingNotice } from '../customNotice/botNotice/tnpsReportingNotice';
export class TNPSSurvey {
    constructor(configuration) {
        this.apiUrl = configuration.apiUrl;
        this.surveyId = configuration.surveyId;
        this.useProbability = configuration.useProbability;
        this.hash = configuration.hash ? configuration.hash : "";
        this.questions = configuration.questions ? configuration.questions : undefined;
        this.usecase = configuration.usecase;
        this.entrychannel = configuration.entrychannel;
        this.customProbability = configuration.customProbability;
        this.sessionId = configuration.sessionId;
    }
    //Calls init method on Sandsiv interface. In case of success calls activate and metadata requests
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            var self = this;
            let asmpData;
            try {
                asmpData = yield Bridge2.getMessageBus().command('InteractionContext.getASMPData');
            }
            catch (_a) {
            }
            return new Promise(function (resolve, reject) {
                try {
                    var initRequest = new XMLHttpRequest();
                    let customerId = self.getCustomerId(asmpData);
                    if (!customerId) {
                        customerId = self.sessionId;
                    }
                    let initUrl = self.getInitUrl(self.apiUrl, self.surveyId, customerId);
                    if (!initUrl) {
                        let tnpsError = new TNPSError();
                        tnpsError.status = 400;
                        tnpsError.error = "Could not create InitUrl. CustomerID: " + JSON.stringify(customerId);
                        reject(tnpsError);
                        return;
                    }
                    initRequest.onreadystatechange = function () {
                        if (initRequest.readyState == 4) {
                            if (initRequest.status == 200) {
                                // Request finished. Do processing here.
                                let initResponse = JSON.parse(initRequest.responseText);
                                self.hash = initResponse.hash;
                                self.questions = initResponse.questions;
                                let questionTexts = initResponse.questions.map((q) => q.language.text);
                                let shouldBeShown = true;
                                if (self.useProbability) { //in case of probability usage
                                    let probabilitySetting = initResponse.settings.DIGI_PROBABILITY_OF_APPEARANCE;
                                    if (self.customProbability) {
                                        probabilitySetting = self.customProbability;
                                    }
                                    let randomProb = Math.random() * 100; //generate probability
                                    //console.log("Probability setting: [" + probabilitySetting + "], generated probability: [" + randomProb+ "]");
                                    if (randomProb > probabilitySetting) {
                                        shouldBeShown = false;
                                    }
                                }
                                let res = { show: shouldBeShown, hash: self.hash, questions: self.questions };
                                if (shouldBeShown) {
                                    self.activate(self.apiUrl, self.hash).then(() => {
                                        self.metadata(self.apiUrl, self.hash, asmpData).then(() => {
                                            for (let index in questionTexts) {
                                                let qInd = Number(index) + 1;
                                                res["question" + qInd] = questionTexts[index];
                                            }
                                            //console.log(res);
                                            resolve(res);
                                        }).catch(() => {
                                            let tnpsError = new TNPSError();
                                            tnpsError.status = 500;
                                            tnpsError.error = "Could not set metadata. Hash: " + self.hash;
                                            reject(tnpsError);
                                        });
                                    }).catch(() => {
                                        let tnpsError = new TNPSError();
                                        tnpsError.status = 500;
                                        tnpsError.error = "Could not activate survey. Hash: " + self.hash;
                                        reject(tnpsError);
                                    });
                                }
                                else {
                                    resolve(res);
                                }
                            }
                            else {
                                let tnpsError = new TNPSError();
                                tnpsError.status = initRequest.status;
                                if (tnpsError.status == 422) {
                                    tnpsError.error = "Customer with id: " + customerId + " is in quarantine.";
                                }
                                else {
                                    tnpsError.error = "Init request wasn't sucessful: httpCode: " + initRequest.status + " URL:  " + initUrl.toString();
                                }
                                reject(tnpsError);
                            }
                        }
                    };
                    initRequest.onerror = function () {
                        let tnpsError = new TNPSError();
                        tnpsError.status = 500;
                        tnpsError.error = "Init request wasn't sucessful.";
                        reject(tnpsError);
                    };
                    initRequest.open("GET", initUrl.toString());
                    initRequest.send();
                }
                catch (err) {
                    let tnpsError = new TNPSError();
                    tnpsError.status = 500;
                    tnpsError.error = "Unexpected error: " + JSON.stringify(err);
                    reject(tnpsError);
                }
            });
        });
    }
    //Sends the result of  tnps to sandsiv api
    answer(score, feedbackText, helpful) {
        return __awaiter(this, void 0, void 0, function* () {
            var self = this;
            return new Promise(function (resolve, reject) {
                try {
                    if (!self.questions || self.hash == "") {
                        reject();
                    }
                    let message3 = {};
                    message3[helpful] = helpful;
                    let answers = { "answers": [{ "id": self.questions[0].id, "message": score },
                            { "id": self.questions[1].id, "message": feedbackText },
                            { "id": self.questions[2].id, "message": message3 }
                        ] };
                    //console.log(JSON.stringify(answers));
                    self.executeRequest("answer", "POST", self.apiUrl + `${self.hash}/`, answers).then(() => {
                        resolve();
                    }).catch(() => { reject(); });
                }
                catch (error) {
                    reject();
                }
            });
        });
    }
    executeRequest(callName, methodName, url, body) {
        return new Promise(function (resolve, reject) {
            //console.log(url);
            var putRequest = new XMLHttpRequest();
            putRequest.onreadystatechange = function () {
                if (putRequest.readyState == 4) {
                    if (putRequest.status == 200) {
                        //console.log(`${callName} call was successful`);
                        resolve();
                    }
                    else {
                        reject();
                    }
                }
            };
            putRequest.onerror = function () {
                console.error(`Error happened during ${callName} call`);
                reject();
            };
            putRequest.open(methodName, url);
            if (body != null) {
                //console.log(body);
                putRequest.setRequestHeader('Content-Type', 'application/json');
            }
            putRequest.send(JSON.stringify(body));
        });
    }
    activate(apiUrl, hash) {
        return this.executeRequest("activate", "PUT", apiUrl + `${hash}/activate`, null);
    }
    metadata(apiUrl, hash, asmpData) {
        let metadataRequest = {
            Country_Code: "AUT",
            Agent_ID: "Kara",
            Agent_Name: "Kara",
            Supervisor_ID: "Kara",
            Supervisor_Name: "Kara",
            OPCO: "A1",
            Brand: "A1",
            INITIAL_URL: this.entrychannel,
            EVENT_ID: this.usecase
        };
        if (asmpData) {
            metadataRequest["Unique_Customer_ID"] = asmpData.account_kumsid;
            metadataRequest["Online_Event"] = asmpData.login_type;
            metadataRequest["TAG_Custom_Field_3"] = asmpData.customer_type;
            metadataRequest["TAG_Custom_Field_4"] = asmpData.opennet_role;
            metadataRequest["TAG_Custom_Field_5"] = asmpData.username;
            metadataRequest["Mobile_Number"] = (asmpData.billing_msisdn != null) ? asmpData.billing_msisdn : "";
        }
        //console.log("MetadataRequest: " + JSON.stringify(metadataRequest));
        return this.executeRequest("metadata", "PUT", apiUrl + `${hash}/metadata`, metadataRequest);
    }
    //returns url used for Init call
    getInitUrl(apiUrl, surveyId, customerId) {
        try {
            const initUrl = new URL(apiUrl + `${surveyId}/`);
            const initParams = new URLSearchParams();
            if (customerId) {
                initParams.set('customerId', `${customerId}`);
            }
            initParams.set('language', 'de');
            initUrl.search = initParams.toString();
            return initUrl;
        }
        catch (err) {
            return null;
        }
    }
    getCustomerId(asmpData) {
        if (asmpData) {
            if (asmpData.account_kumsid) {
                return asmpData.account_kumsid;
            }
            else if (asmpData.billing_msisdn) {
                return asmpData.billing_msisdn;
            }
        }
        return "";
    }
}
TNPSSurvey.createCustomNoticeEvent = (score, text, helpful, dismissed, displayed, error) => {
    return new TNPSReportingNotice(score, text, helpful, dismissed, displayed, error);
};
export class TNPSError {
}
